import { Button } from "@omni/ui/components/Button/button.component";
import classnames from "classnames";
import { ReactNode, SyntheticEvent } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type ProductTileButtonProps = {
    onClick: (e: SyntheticEvent<HTMLButtonElement>) => Promise<void> | void;
    showOutline: boolean;
    children: ReactNode;
    className?: string;
};

const ProductTileButtonComponent = ({
    onClick,
    showOutline,
    children,
    className
}: ProductTileButtonProps) => {
    const { t } = useGranite();

    return (
        <Button
            fullWidth={false}
            type="button"
            test="productTile-button-order"
            disabled={showOutline}
            outline={showOutline}
            onClick={onClick}
            className={classnames(className, showOutline && "cursor-default")}
            aria-label={t("accessibility.productTileButton.addToCart")}
        >
            {children}
        </Button>
    );
};

export default ProductTileButtonComponent;
